import { useEffect, useState } from 'react';
import { useExecuteHealthDump } from 'data';
import { useNotifications } from './toast';
import { download } from '../helpers';

export const useHealthDumpDownload = (name: string) => {
  const { showInfoMessage } = useNotifications();
  const [isDumpDownload, setIsDumpDownload] = useState<boolean>(false);
  const { data: healthDumpFile, isFetching: isDumpFetching } = useExecuteHealthDump(name, {
    enabled: isDumpDownload,
  });

  const onCreateDump = () => setIsDumpDownload(true);

  const downloadDump = () => download(healthDumpFile, name, 'application/zip');

  useEffect(() => {
    if (isDumpDownload && !isDumpFetching) {
      showInfoMessage('Download started');
      downloadDump();
      setIsDumpDownload(false);
    }
  }, [healthDumpFile, isDumpFetching, isDumpDownload]);

  return {
    onCreateDump,
    isDumpFetching,
  };
};
